import Vue from 'vue'
import { MediaQueries } from 'vue-media-queries'

const mediaQueries = new MediaQueries()

Vue.use(mediaQueries)

export default mediaQueries
